module.exports = __webpack_public_path__ + "img/Austin-Perry.b4718aec.png";